import card from './card';
import form from './form';
import table from './table';
export default {
  card,
  form,
  table,
};
